import { render, staticRenderFns } from "./FavoriteAddButton.vue?vue&type=template&id=d923e286&"
import script from "./FavoriteAddButton.vue?vue&type=script&lang=js&"
export * from "./FavoriteAddButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\LrGithub\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d923e286')) {
      api.createRecord('d923e286', component.options)
    } else {
      api.reload('d923e286', component.options)
    }
    module.hot.accept("./FavoriteAddButton.vue?vue&type=template&id=d923e286&", function () {
      api.rerender('d923e286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/favorite-add-button/FavoriteAddButton.vue"
export default component.exports